import { api } from "../../api";

export default async function storeCardMethod(
  token: string,
  fullName: string,
  cpf: string
): Promise<number> {
  try {
    const { status } = await api.post("/billing/payments/card", {
      token,
      fullName,
      cpf,
    });

    return status;
  } catch (err) {
    console.log(err);
    return 500;
  }
}
